import { render, staticRenderFns } from "./CoachProfileCard.vue?vue&type=template&id=dd140bf6&scoped=true&"
import script from "./CoachProfileCard.vue?vue&type=script&lang=ts&"
export * from "./CoachProfileCard.vue?vue&type=script&lang=ts&"
import style0 from "./CoachProfileCard.vue?vue&type=style&index=0&id=dd140bf6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd140bf6",
  null
  
)

export default component.exports